import { BlockStack, Box, FooterHelp, Link, Text } from '@shopify/polaris'
import React from 'react'

const color = 'var(--p-color-text-secondary,rgba(97, 97, 97, 1))'

const MyLink = ({ url, children }: { url: string; children: any }) => (
  <a style={{ color }} target="_blank" rel="noopener noreferrer" href={url} children={children} />
)

export const Footer = () => (
  <FooterHelp>
    <Box as="span" paddingBlockEnd="800">
      <BlockStack as="span" inlineAlign="center" gap="200">
        <Text as="span" key="footer-text">
          To learn more, visit <Link url="https://shop.paywhirl.com">shop.PayWhirl.com</Link>
        </Text>
        <Text as="span" tone="subdued" variant="bodySm" key="footer-links">
          <MyLink url="https://app.paywhirl.com/terms">Terms of Use</MyLink>
          {'   •   '}
          <MyLink url="https://app.paywhirl.com/privacy">Privacy</MyLink>
          {'   •   '}
          <MyLink url="https://app.paywhirl.com/data-protection">Data Protection</MyLink>
        </Text>
      </BlockStack>
    </Box>
  </FooterHelp>
)
